import React, {useReducer} from 'react';


const initialState = () => ({
    modalOptions: {
        show: false
    },
    activeTab: 'Residential',
    counter: 0,
    hover: {
        event: undefined,
        item: undefined,
        target:undefined
    }
});


const AppContext = React.createContext();

const reducer = (state, action) => {
    switch (action.type) {
        case 'reset':
            return initialState();
        case 'show-modal':
            return {...state, modalOptions: {show: true}};
        case 'hide-modal':
            return {...state, modalOptions: {show: false}};
        case 'switch-tab':
            return {...state, activeTab: action.payload.tab};
        case 'show-info':
            return {...state, hover: action.payload};
        case 'hide-info':
            return {...state, hover: initialState().hover};
        case 'increase-counter': {
            const counter = state.counter + 1;


            return {...state, counter};
        }
        case 'decrease-counter': {
            const counter = state.counter - 1;


            return {...state, counter};
        }
        case 'reset-counter':
            return {...state, counter: 0};
        default:
            return state;
    }
};

const AppContextProvider = ({children}) => {
    const [state, dispatch] = useReducer(reducer, initialState());
    const value = {state, dispatch};

    return (
        <>
            <AppContext.Provider value={value}>
                {children}
            </AppContext.Provider>
        </>
    );
};

const AppContextConsumer = AppContext.Consumer;

export {AppContext, AppContextProvider, AppContextConsumer};
